export default __webpack_public_path__ + "assets/images/decor.7b2234.png";